import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * URL-backed state for the monitoring page panels.
 *
 * Dos estados viven en la query string de la ruta "/":
 *   - `?v=<imei>`  → vehículo seleccionado (panel de detalle)
 *   - `?list=1`    → lista de vehículos abierta a pantalla completa
 *
 * Todas las mutaciones hacen PUSH (setSearchParams sin `replace`), así el
 * botón atrás del navegador/hardware reconstruye el stack Mapa → Lista →
 * Detalle y todo es deep-linkable. selectDevice borra `list` al fijar `v`
 * para que, estando en el detalle, atrás vuelva a la lista (no al mapa).
 *
 * Toggle semantics: seleccionar el imei ya seleccionado (o pasar null) limpia.
 */
export function useSelectedVehicle() {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedImei = searchParams.get("v");
  const listOpen = searchParams.get("list") === "1";

  const selectDevice = useCallback(
    (imei) => {
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        next.delete("list"); // tap vehículo cierra la lista (stack lista→detalle)
        if (!imei || next.get("v") === imei) {
          next.delete("v");
        } else {
          next.set("v", imei);
        }
        return next;
      });
    },
    [setSearchParams],
  );

  const openList = useCallback(() => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set("list", "1");
      return next;
    });
  }, [setSearchParams]);

  const closeList = useCallback(() => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.delete("list");
      return next;
    });
  }, [setSearchParams]);

  return { selectedImei, selectDevice, listOpen, openList, closeList };
}
